export default __webpack_public_path__ + "static/media/cementFinisher.0088a7f2.jpg";